import { FC, useEffect, useRef, useState } from 'react'
import { useLayout } from '../../../_metronic/layout/core'
import SVG from 'react-inlinesvg'
import { Link, useHistory } from 'react-router-dom'
import { fleurSVGBlack } from '../../utils/constants'

const AddExperiencePausedPage: FC = () => {
    const { config, setLayout } = useLayout()
    const restoreRef = useRef(config)
    const history = useHistory()

    useEffect(() => {
        restoreRef.current = config

        setLayout({
            ...config,
            header: { ...config.header, display: true },
            aside: { ...config.aside, display: true },
            toolbar: { ...config.toolbar, display: false },
            footer: { ...config.footer, display: true },
        })

        return () => setLayout(restoreRef.current)
    }, [])

    return (<div className='tap-flex-center'>
        <div className="tap-add-experience-success-container">
            <div className="tap-add-experience-success-title">
                Experience Paused
            </div>
            <div className="tap-add-experience-success-subtitle">
                Your experience is paused. You can return anytime to edit or publish it from My Experiences
            </div>
            <div className="tap-add-experience-success-icon-wrapper">
                <div className='line-svg'>
                    <SVG src={'/media/svg/nobilis/teams_and_partner/mask-success-line-icon.svg'} />
                </div>
                <div className='icon-svg'>
                    <SVG src={fleurSVGBlack} />
                </div>
                <div className='line-svg'>
                    <SVG src={'/media/svg/nobilis/teams_and_partner/mask-success-line-icon.svg'} />
                </div>
                {/* <div className="tap-add-experience-success-icon" /> */}
            </div>
            <div className="w-100 tap-flex-center">
                <Link to={'/host-experience'} className="tap-add-experience-success-btn-secondary">
                    <div>explore community</div>
                </Link>
            </div>
        </div>
    </div>)
}

export { AddExperiencePausedPage }